<div fxLayout="column" style="position: relative; margin: 10px;" class="dialog-get-asset">
    @if (multiSelect && showImport) {
        <div class="btn-import">
            <button style="margin: 5px; z-index: 10000" mat-raised-button color="warn" (click)="import()">
                <mat-icon>downloading</mat-icon>
                {{ 'general.insert' | transloco }}
            </button>
        </div>
    }

    <div class="list-container main-container">
        @switch (m_data.mode) {
            <!-- <ul [ngSwitch]="m_data.mode"> -->
            @case ('RESOURCE:SOUND') {
                <div>
                    <mat-tab-group [@.disabled]="true" mat-stretch-tabs="false" mat-align-tabs="start">
                        <mat-tab label="{{'general.resources' | transloco}}">
                            <ng-template matTabContent>
                                <app-resource-list #resourceList (itemSelected)="onItemSelected($event, 'MUSIC_SELECTED')" [dialogGetAsset]="m_data"
                                                   [setResources]="resources">
                                </app-resource-list>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            }
            @case ('SCENE_RESOURCE:PLAYER') {
                <div>
                    <!-- <h1 style="font-size: 1.5em">{{'general.content' | transloco}}</h1> -->
                    <mat-tab-group [@.disabled]="true" mat-stretch-tabs="false" mat-align-tabs="start">
                        <mat-tab label="{{'general.resources' | transloco}}">
                            <ng-template matTabContent>
                                <app-resource-list #resourceList (itemSelected)="onItemSelected($event, 'RESOURCE_SELECTED')" [dialogGetAsset]="m_data"
                                                   [setResources]="resources">
                                </app-resource-list>
                            </ng-template>
                        </mat-tab>
                        <mat-tab label="{{'general.library' | transloco}}">
                            <ng-template matTabContent>
                                <app-scene-importer (itemSelected)="onItemSelected($event, 'SCENE_CREATED')" [dialogGetAsset]="m_data"></app-scene-importer>
                            </ng-template>
                        </mat-tab>
                        <mat-tab label="{{'general.scenes' | transloco}}">
                            <ng-template matTabContent>
                                <app-scene-list-details #sceneList (itemSelected)="onItemSelected($event, 'SCENE_SELECTED')" [dialogGetAsset]="m_data"></app-scene-list-details>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            }
            @case ('SCENE_RESOURCE_NOLIB') {
                <div>
                    <!-- <h1 style="font-size: 1.5em">{{'general.content' | transloco}}</h1> -->
                    <mat-tab-group [@.disabled]="true" mat-stretch-tabs="false" mat-align-tabs="start">
                        <mat-tab label="{{'general.resources' | transloco}}">
                            <ng-template matTabContent>
                                <app-resource-list #resourceList (itemSelected)="onItemSelected($event, 'RESOURCE_SELECTED')"
                                                   [autoSelectTabIndex]="1" [dialogGetAsset]="m_data" [setResources]="resources">
                                </app-resource-list>
                            </ng-template>
                        </mat-tab>
                        <mat-tab label="{{'general.scenes' | transloco}}">
                            <ng-template matTabContent>
                                <app-scene-list-details #sceneList (itemSelected)="onItemSelected($event, 'SCENE_SELECTED')" [dialogGetAsset]="m_data"></app-scene-list-details>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            }
            @case ('SCENE:MIME') {
                <div>
                    <!-- <h1 style="font-size: 1.5em">{{'general.content' | transloco}}</h1> -->
                    <mat-tab-group [@.disabled]="true" mat-stretch-tabs="false" mat-align-tabs="start">
                        <mat-tab label="{{'general.library' | transloco}}">
                            <ng-template matTabContent>
                                <app-scene-importer (itemSelected)="onItemSelected($event, 'SCENE_CREATED')" [dialogGetAsset]="m_data"></app-scene-importer>
                            </ng-template>
                        </mat-tab>
                        <mat-tab label="{{'general.scenes' | transloco}}">
                            <ng-template matTabContent>
                                <app-scene-list-details #sceneList (itemSelected)="onItemSelected($event, 'SCENE_SELECTED')" [dialogGetAsset]="m_data"></app-scene-list-details>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            }
            @case ('SCENE:PLAYER') {
                <div>
                    <!-- <h1 style="font-size: 1.5em">{{'general.content' | transloco}}</h1> -->
                    <mat-tab-group [@.disabled]="true" mat-stretch-tabs="false" mat-align-tabs="start">
                        <mat-tab label="{{'general.scenes' | transloco}}">
                            <ng-template matTabContent>
                                <app-scene-list-details #sceneList (itemSelected)="onItemSelected($event, 'SCENE_SELECTED')" [dialogGetAsset]="m_data"></app-scene-list-details>
                            </ng-template>
                        </mat-tab>
                        <mat-tab label="{{'general.library' | transloco}}">
                            <ng-template matTabContent>
                                <app-scene-importer (itemSelected)="onItemSelected($event, 'SCENE_CREATED')" [dialogGetAsset]="m_data"></app-scene-importer>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            }
            @case ('SCENE:PLAYER_ASSIGNABLE') {
                <div>
                    <mat-tab-group [@.disabled]="true" mat-stretch-tabs="false" mat-align-tabs="start">
                        <mat-tab label="{{'general.scenes' | transloco}}">
                            <ng-template matTabContent>
                                <app-scene-list-details #sceneList (itemSelected)="onItemSelected($event, 'SCENE_SELECTED')" [dialogGetAsset]="m_data"></app-scene-list-details>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            }
            @case ('SCENE:ALL') {
                <div>
                    <mat-tab-group [@.disabled]="true" mat-stretch-tabs="false" mat-align-tabs="start">
                        <mat-tab label="{{'general.scenes' | transloco}}">
                            <ng-template matTabContent>
                                <app-scene-list-details #sceneList (itemSelected)="onItemSelected($event, 'SCENE_SELECTED')" [dialogGetAsset]="m_data"></app-scene-list-details>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            }
            @case ('RESOURCE:ALL') {
                <div>
                    <mat-tab-group [@.disabled]="true" mat-stretch-tabs="false" mat-align-tabs="start">
                        <mat-tab label="{{'general.resources' | transloco}}">
                            <ng-template matTabContent>
                                <app-resource-list #resourceList (itemSelected)="onItemSelected($event, 'RESOURCE_SELECTED')" [dialogGetAsset]="m_data"
                                                   [setResources]="resources"></app-resource-list>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            }
            @case ('RESOURCE:IMAGES') {
                <div>
                    <mat-tab-group [@.disabled]="true" mat-stretch-tabs="false" mat-align-tabs="start">
                        <mat-tab label="{{'general.resources' | transloco}}">
                            <ng-template matTabContent>
                                <app-resource-list #resourceList (itemSelected)="onItemSelected($event, 'RESOURCE_SELECTED')" [dialogGetAsset]="m_data"
                                                   [setResources]="resources"></app-resource-list>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            }
            @case ('RESOURCE:SOUND') {
                <div>
                    <mat-tab-group [@.disabled]="true" mat-stretch-tabs="false" mat-align-tabs="start">
                        <mat-tab label="{{'general.resources' | transloco}}">
                            <ng-template matTabContent>
                                <app-resource-list #resourceList (itemSelected)="onItemSelected($event, 'RESOURCE_SELECTED')" [dialogGetAsset]="m_data"
                                                   [setResources]="resources"></app-resource-list>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            }
            @case ('SCENE:LIBRARY') {
                <div>
                    <app-create-scene (itemSelected)="onItemSelected($event, 'SCENE_CREATED')" [dialogGetAsset]="m_data"></app-create-scene>
                </div>
            }
            @case ('RESORUCE:LIBRARY') {
                <div>
                    <app-create-resource (itemSelected)="onItemSelected($event, 'RESOURCE_CREATED')" [dialogGetAsset]="m_data"></app-create-resource>
                </div>
            }
            <!-- </ul> -->
        }
    </div>
</div>
